import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { Spinner } from 'reactstrap';
import './LoadingScreen.scss';

interface Props {
    text?: string;
    width?: string;
    error?: boolean;
}

const LoadingScreen: React.SFC<Props> = (props) => {
    return (
        <div className={'outer'}>
            <div className="text" style={{ width: props.width || '300px' }}>
                {props.error ? <FontAwesomeIcon className="mr-4" style={{fontSize: '2em'}} icon={['fal', 'exclamation-circle']} /> :
                    (
                        <Spinner
                            size="md"
                            style={{
                                marginRight: '1.5rem'
                            }}
                        />
                    )}
                <h3 style={{display: 'inline'}}>
                    {props.text}
                </h3>
            </div>
        </div>
    );
};

export default LoadingScreen;
